import './Head.css'
import Music from '../Music/Music';
import React from 'react';

const Head = () => {

    return (
        <div className='Head'>
            <Music />
        </div>
    )
}

export default Head;